/* e-Ko Skin – cos instant (Claude, 7 oct 2026)
 * Deschide cosul lateral IMEDIAT ce se apasa orice buton "Adauga in cos"
 * (pagina de produs, recomandari, aplicatii precum Wiser), fara sa mai astepte serverul.
 * In cos apare pe loc un rand "Se adauga..." cu poza si numele produsului;
 * continutul real (pret, subtotal, cadou) il inlocuieste cand raspunde serverul.
 * Daca adaugarea esueaza (ex. stoc epuizat), cosul se inchide singur si eroarea ramane vizibila pe pagina.
 */
(function () {
  'use strict';
  if (window.__ekoInstantCart) return;
  window.__ekoInstantCart = true;

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var INTERACTION_WINDOW = 2000; // ms intre click si cererea catre /cart/add
  var FALLBACK_REFRESH = 2500;   // daca nimeni nu actualizeaza cosul dupa raspuns, il reincarcam noi
  var HARD_TIMEOUT = 8000;

  var lastInteraction = null;
  var pending = null;

  /* ---------- stiluri ---------- */
  var css = ''
    + 'cart-drawer.eko-cart-pending::before{content:"";position:absolute;top:0;left:0;right:0;height:3px;z-index:20;'
    + 'background:linear-gradient(90deg,transparent,#f16bb4,transparent) no-repeat;background-size:40% 100%;animation:ekoCartBar 1s linear infinite;}'
    + '@keyframes ekoCartBar{from{background-position:-40% 0}to{background-position:140% 0}}'
    + 'cart-drawer.eko-cart-pending .checkout-buttons{opacity:.55;pointer-events:none;}'
    + '.eko-pending-item{display:flex;gap:12px;align-items:center;padding:12px 0;border-bottom:1px solid rgba(0,0,0,.08);animation:ekoPendIn .18s ease-out;transition:opacity .25s;}'
    + '.eko-pending-item.is-done{opacity:0;}'
    + '.eko-pending-item__img{flex:0 0 64px;width:64px;height:64px;border-radius:8px;background:#f6f6f3;overflow:hidden;display:grid;place-items:center;}'
    + '.eko-pending-item__img img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;}'
    + '.eko-pending-item__body{min-width:0;flex:1;}'
    + '.eko-pending-item__title{font-size:13px;line-height:1.35;font-weight:600;color:#1e1a1c;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}'
    + '.eko-pending-item__status{display:flex;align-items:center;gap:6px;margin-top:4px;font-size:12px;color:#6b6467;}'
    + '.eko-pending-item__spinner{width:12px;height:12px;border:2px solid rgba(176,74,114,.25);border-top-color:#b04a72;border-radius:50%;animation:ekoSpin .7s linear infinite;}'
    + '@keyframes ekoSpin{to{transform:rotate(360deg)}}'
    + '@keyframes ekoPendIn{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}';
  var style = document.createElement('style');
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);

  /* ---------- ultima interactiune a clientului (click / trimitere formular) ---------- */
  function remember(e) {
    var t = e.target;
    // butoanele de cantitate / stergere din cos nu deschid nimic
    if (!(t instanceof Element) || t.closest('.cart-item')) return;
    if (e.type === 'click') t = t.closest('button, a, [role="button"], input[type="submit"], input[type="button"]') || t;
    lastInteraction = { el: t, t: Date.now() };
  }
  document.addEventListener('click', remember, true);
  document.addEventListener('submit', remember, true);

  function takeInteraction() {
    if (!lastInteraction || Date.now() - lastInteraction.t > INTERACTION_WINDOW) return null;
    var el = lastInteraction.el;
    lastInteraction = null; // o singura deschidere per click (aplicatiile care adauga automat nu redeschid cosul)
    return el;
  }

  /* ---------- cosul lateral ---------- */
  function getDrawer() {
    return document.querySelector('cart-drawer.js-cart-drawer');
  }

  // Daca cosul e deja deschis, a doua deschidere (cea a temei, dupa raspunsul serverului) nu mai face nimic
  function patchDrawer(d) {
    if (!d || d.__ekoPatched) return;
    d.__ekoPatched = true;
    d.open = function (opener, focusEl, cb) {
      if (this.hasAttribute('open')) {
        if (typeof cb === 'function') cb();
        return;
      }
      return Object.getPrototypeOf(this).open.apply(this, arguments);
    };
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () { patchDrawer(getDrawer()); });
  }

  function onCartPage() {
    return !!(document.body && document.body.classList.contains('template-cart'));
  }

  function drawerEnabled() {
    var s = window.theme && window.theme.settings;
    return !s || !s.afterAddToCart || s.afterAddToCart === 'drawer';
  }

  /* ---------- previzualizarea produsului adaugat ---------- */
  // incearca selectorii in ordinea prioritatii (querySelector cu lista ar lua primul element din pagina)
  function pick(scope, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var found = scope.querySelector(selectors[i]);
      if (found) return found;
    }
    return null;
  }

  function previewFrom(el) {
    var scope = el.closest('[data-eko-rec], .product-block, .quickbuy-content, .product-info, .js-product');
    if (!scope) {
      // aplicatii (ex. Wiser): urcam pana gasim un card care are o poza
      var n = el;
      for (var i = 0; i < 6 && n && n !== document.body; i++) {
        if (n.querySelector && n.querySelector('img')) { scope = n; break; }
        n = n.parentElement;
      }
    }
    if (!scope) return { title: '', img: '' };
    var img = pick(scope, ['.media-gallery .main-image .slider__item.is-active img', '.eko-recs__img img', '.product-block__image--active img', '.media-gallery img', 'img']);
    var titleEl = pick(scope, ['.eko-recs__name', '.product-block__title', '.product-title', '[class*="itle"]']);
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (title.length > 90) title = title.slice(0, 88) + '…';
    return { title: title, img: img ? (img.currentSrc || img.src || '') : '' };
  }

  function buildRow(info) {
    var row = document.createElement('div');
    row.className = 'eko-pending-item';
    row.setAttribute('aria-live', 'polite');

    var imgWrap = document.createElement('div');
    imgWrap.className = 'eko-pending-item__img';
    if (info.img) {
      var im = document.createElement('img');
      im.src = info.img;
      im.alt = '';
      imgWrap.appendChild(im);
    }

    var body = document.createElement('div');
    body.className = 'eko-pending-item__body';
    var t = document.createElement('div');
    t.className = 'eko-pending-item__title';
    t.textContent = info.title || 'Produsul tău';
    var st = document.createElement('div');
    st.className = 'eko-pending-item__status';
    var sp = document.createElement('span');
    sp.className = 'eko-pending-item__spinner';
    st.appendChild(sp);
    st.appendChild(document.createTextNode('Se adaugă în coș…'));
    body.appendChild(t);
    body.appendChild(st);

    row.appendChild(imgWrap);
    row.appendChild(body);
    return row;
  }

  /* ---------- ciclul unei adaugari ---------- */
  function start() {
    if (onCartPage() || !drawerEnabled()) return null;
    var el = takeInteraction();
    if (!el) return null;
    var drawer = getDrawer();
    if (!drawer || !window.customElements || !customElements.get('cart-drawer')) return null;
    patchDrawer(drawer);

    finish(pending, true);

    // cos gol: aratam zona de produse in locul mesajului "cosul e gol" (tema reface clasele corecte la actualizare)
    var content = drawer.querySelector('[data-merge-attributes="content-container"]');
    var empty = drawer.querySelector('[data-merge-attributes="empty-container"]');
    if (content) content.classList.remove('cart-drawer__content--hidden');
    if (empty) empty.classList.add('cart-drawer__empty-content--hidden');

    var row = buildRow(previewFrom(el));
    var list = drawer.querySelector('[data-merge-list="cart-items"]');
    if (list) {
      list.insertBefore(row, list.firstChild);
    } else {
      var upper = drawer.querySelector('.cart-drawer__content-upper');
      if (upper) upper.appendChild(row);
    }
    drawer.classList.add('eko-cart-pending');

    var wasOpen = drawer.hasAttribute('open');
    if (!wasOpen) {
      var opener = el.matches('form') ? (el.querySelector('[name="add"], [type="submit"]') || el) : (el.closest('button, a, [role="button"]') || el);
      try { drawer.open(opener); } catch (err) { /* nimic */ }
    }

    var token = { drawer: drawer, row: row, openedByUs: !wasOpen, responded: false, timers: [] };
    token.timers.push(setTimeout(function () { finish(token, false); }, HARD_TIMEOUT));
    pending = token;
    return token;
  }

  function refreshDrawer(drawer) {
    var form = drawer && drawer.querySelector('cart-form');
    // daca tema deja reincarca cosul, nu mai trimitem inca o cerere
    if (form && typeof form.refresh === 'function' && !form.classList.contains('cart-form--refreshing')) {
      try { form.refresh(); } catch (err) { /* nimic */ }
    }
  }

  function succeeded(token) {
    if (!token || pending !== token) return;
    token.responded = true;
    // Tema actualizeaza singura cosul; daca n-o face (unele aplicatii), il reincarcam noi
    token.timers.push(setTimeout(function () {
      if (pending === token) refreshDrawer(token.drawer);
    }, FALLBACK_REFRESH));
  }

  function failed(token) {
    if (!token || pending !== token) return;
    var drawer = token.drawer;
    var openedByUs = token.openedByUs;
    finish(token, true);
    if (openedByUs && drawer.hasAttribute('open')) {
      try { drawer.close(); } catch (err) { /* nimic */ }
    }
    refreshDrawer(drawer); // reface starea corecta a cosului
  }

  function finish(token, instant) {
    if (!token) return;
    token.timers.forEach(clearTimeout);
    token.timers = [];
    if (pending === token) pending = null;
    token.drawer.classList.remove('eko-cart-pending');
    var row = token.row;
    if (!row || !row.parentNode) return;
    if (instant) {
      row.parentNode.removeChild(row);
    } else {
      // lasam produsul real sa apara, apoi stingem randul temporar
      row.classList.add('is-done');
      setTimeout(function () { if (row.parentNode) row.parentNode.removeChild(row); }, 450);
    }
  }

  // Cand tema a pus continutul nou in cos, randul temporar dispare
  document.addEventListener('on:cart:after-merge', function (e) {
    if (!pending || !pending.responded) return;
    if (!(e.target instanceof Element) || !e.target.closest('cart-drawer')) return;
    finish(pending, false);
  });

  /* ---------- interceptarea cererilor catre /cart/add ---------- */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var token = null;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) ? input.url : String(input || '');
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && ADD_RE.test(url)) token = start();
      } catch (err) { token = null; }

      var p = origFetch.apply(this, arguments);
      if (token) {
        p.then(function (res) {
          if (res && res.ok) succeeded(token); else failed(token);
        }, function () { failed(token); });
      }
      return p;
    };
  }

  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__ekoAdd = /^post$/i.test(String(method)) && ADD_RE.test(String(url)); } catch (err) { this.__ekoAdd = false; }
    return xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__ekoAdd) {
      var token = start();
      if (token) {
        var xhr = this;
        xhr.addEventListener('loadend', function () {
          if (xhr.status >= 200 && xhr.status < 300) succeeded(token); else failed(token);
        });
      }
    }
    return xSend.apply(this, arguments);
  };
})();
